import { NgModule } from '@angular/core';

import { RwcFinishSpanDirective, RwcStartSpanDirective } from './tracing.directive';

/**
 * @deprecated Both RwcStartSpanDirective, RwcFinishSpanDirective are standalone directives and should be used directly.
 */
@NgModule({
    imports: [RwcStartSpanDirective, RwcFinishSpanDirective],
    exports: [RwcStartSpanDirective, RwcFinishSpanDirective]
})
export class TracingModule {}
